<script>
  import { User, Doc } from "sveltefire";
  import AboutFollowing from "./AboutFollowing.svelte";
  
  import List from "./List.svelte";
  import SubNav from "./SubNav.svelte";
  // import { dotCircleO } from "svelte-awesome/icons";
  import {shortDate} from  './helpers.js';
  import Footer from "./Footer.svelte"
  import { listId, listQuery, sectionId, newsletterId, whenLast, followingArray, isDisplayIssue } from './stores.js';

  // console.log('@Links $listQuery='+listQuery+'  listId='+$listId);
  const getWhenLast = function(){
    let diff=60*60;  //seconds in one hour or 3600 sec
    let nowSec=Math.round((new Date()).getTime() / 1000 );
    let whenExpires=localStorage.getItem("whenExpires");
    //console.log('whenExpires='+whenExpires);
    if (whenExpires==null){  //first time loading app
        localStorage.setItem("whenExpires",nowSec);
        whenExpires=nowSec;
        localStorage.setItem("whenLast",0);  //all issues will be displayed
    }else if (nowSec-whenExpires>diff) {
        localStorage.setItem("whenLast",whenExpires);  
        localStorage.setItem("whenExpires",nowSec);
        whenExpires=nowSec;
    }
    //console.log('whenLast='+localStorage.getItem("whenLast"))
    return localStorage.getItem("whenLast")
    // may change this to read from cloud
  }

  whenLast.set(getWhenLast());
  $: whenLastDisplay=shortDate($whenLast);

  let isShowWhyFollow = true;
  $: if ($followingArray.length==0){
    isShowWhyFollow = true;
  } else {
    isShowWhyFollow = false;
  }
  // console.log("@Links.svelte listId="+JSON.stringify($listId))
</script>

<!-- <svelte:head>
  <meta property="og:title" content="{newSubject} ({pubDate})">
  <meta property="og:description" content="Newsletter from {newFrom}">
  <meta property="og:url" content="https://reading.email/newsletter/{newsletterId}">
  <meta property="og:site_name" content="{newFrom} on Reading.email">
</svelte:head> -->

<!-- <h1>Links Component @Links</h1> -->
<div class:displaynone={!$isDisplayIssue}>
  <User let:user let:auth>
    
    <div class="asideheader">
      <span class="whenLast">Previous visit: <span class="whenLastDate">{whenLastDisplay}</span>
    </div>
    <SubNav></SubNav>

    <div class="signed-in">
      <!-- <h2>Links Signed In</h2><p>{listQuery}</p> -->
      <!-- <Doc path={`users/${user.uid}`} let:data={userdata}>
        {#if isShowWhyFollow}
          <SignedinFollowing></SignedinFollowing>
        {/if} -->
        <!-- <p>@Links before List listquery={$listQuery}</p> -->
        <List listQuery="{$listQuery}"></List> 
      <!-- </Doc> -->
    </div>

    <div slot="signed-out" class="signed-out">
      <!-- <h2>Links Signed Out @Links</h2> -->
      <AboutFollowing></AboutFollowing>
      <List listQuery="welcome"></List>
    </div>
  </User>
</div>

<Footer></Footer>

<style>
  .asideheader {color: cornflowerblue; padding: 0.5rem; background-color: whitesmoke;
    border-bottom-color: cornflowerblue; border-bottom: solid; border-width: 3px;}
  .whenLast {color: black;}
</style>